import Rollbar from 'rollbar';

const rollbar =
  process.env.NODE_ENV === 'production' 
  ? new Rollbar({
      accessToken: process.env.VUE_APP_ROLLBAR_CLIENT_ACCESS_KEY,
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        // Track your events to a specific version of code for better visibility into version health
        code_version: '1.0.0',
        // Add custom data to your events by adding custom key/value pairs like the one below
        environment: process.env.NODE_ENV
      }
    })
  : {
    error: () => {
      // console.error(error);
    }
  }

export default rollbar;